import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import LanguageButtons from "./../Shared/LanguageButtons";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import Logo from "./../../Components/Logo_V";

import { useTheme, createTheme, ThemeProvider } from "@mui/material/styles";

import { getErrorTranslateID } from "./../../HelperFunctions/ErrorDisplayFunctions";

import { useNavigate } from "react-router-dom";

let env = require("./../../../../env");

export default function VerticalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    loading,
    errorCode,
    isNotMobile,
    kioskkey,
    showLoginConfirmModal,
    loginLocationAddress,
    loginLocationCode,
    loginLocationName,
    loginWarning,
    warningSwitchFromName,
    warningSwitchFromCode,
    confirmLoginCancelFunc,
    confirmLoginAdvanceFunc,
    showVersionMismatchModal,
    setShowVersionMismatchModal,
    latestVersion
  } = props;

  const navigate = useNavigate();

  const navigateDebug = async () => {
    navigate("/debugsocketio");
  };

  const theme = useTheme();

  const kioskverticalstyles_2 = useKioskVerticalStyles();

  const vtheme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              height: "8vh",
              width: "46vw",
              fontSize: "6vh"
            }
          }),
          input: ({ ownerState }) => ({
            ...{
              textAlign: "center"
            }
          })
        }
      }
    }
  });

  const showLoginConfirmModalBoolean =
    showLoginConfirmModal && !showVersionMismatchModal;

  return (
    <div style={kioskverticalstyles_2.flexBackgroundOrange}>
      <div style={kioskverticalstyles_2.logo}>
        <center>
          <Logo />
        </center>
      </div>

      <div
        style={{
          ...kioskverticalstyles_2.instructionDiv,
          ...kioskverticalstyles_2.configuration.instructionDiv
        }}
      >
        <div>
          <Translate value="application.configuration.configuration" />
        </div>
      </div>

      <div
        style={{
          ...kioskverticalstyles_2.whiteDiv,
          ...kioskverticalstyles_2.flexcenterDiv
        }}
      >
        <div style={kioskverticalstyles_2.configuration.whitecontentdiv}>
          {!showLoginConfirmModal && !showVersionMismatchModal && (
            <>
              <Typography
                variant="h5"
                style={kioskverticalstyles_2.configuration.enterkeytext}
              >
                <Translate value="application.configuration.enterkey" />
              </Typography>
              <center>
                <ThemeProvider theme={vtheme}>
                  <TextField
                    id="KioskKey"
                    label=""
                    value={kioskkey}
                    style={{ marginBottom: "5vh" }}
                    onChange={event => {
                      let newText = event.target.value;
                      newText = newText.toUpperCase().trim();
                      setKioskkeyFunc(newText);
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white"
                      }
                    }}
                  />
                </ThemeProvider>
              </center>
              <div style={kioskverticalstyles_2.configuration.buttoncontainer}>
                <div style={kioskverticalstyles_2.configuration.buttondiv}>
                  {/* DEBUG BUTTONS */}
                  {/* <Button
                fullWidth
                variant="contained"
                disabled={loading}
                onClick={navigateDebug}
                style={{ marginBottom: "3vh" }}
              >
                <span className="fontSecondaryText">Debug SocketIO</span>
              </Button> */}
                  {/* END DEBUG BUTTONS */}

                  <Button
                    fullWidth
                    variant="contained"
                    disabled={loading}
                    onClick={nextFunc}
                    style={kioskverticalstyles_2.configuration.nextbutton}
                  >
                    <span className="fontSecondaryText">
                      <Translate value="application.next" />
                    </span>
                  </Button>
                </div>
              </div>
              <div>
                <Typography
                  variant="body2"
                  className="fontSecondaryText"
                  style={{
                    color: "red",
                    marginTop: theme.spacing(0.5),
                    fontSize: "2vh",
                    textAlign: "center"
                  }}
                >
                  <Translate value={getErrorTranslateID(errorCode)} />
                </Typography>
              </div>
            </>
          )}

          {showVersionMismatchModal && (
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around",
                textAlign: "center"
              }}
            >
              <div>
                <div style={{ fontSize: "3vh", marginBottom: "3vh" }}>
                  <Translate value="application.configuration.versionmismatch" />
                </div>

                <div
                  style={{
                    fontSize: "2.2vh",
                    marginTop: "2vh",
                    fontStyle: "italic"
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    <Translate value="application.configuration.warning" />:{" "}
                  </span>
                  <Translate
                    value="application.configuration.versionmismatchwarning"
                    latestversion={latestVersion}
                    currentversion={env.REACT_APP_VERSION}
                  />
                </div>
              </div>
              <div>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={confirmLoginCancelFunc}
                  style={
                    kioskverticalstyles_2.configuration.confirmcancelbutton
                  }
                >
                  <span className="fontSecondaryText">
                    <Translate value="application.back" />
                  </span>
                </Button>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={() => setShowVersionMismatchModal(false)}
                  style={kioskverticalstyles_2.configuration.confirmnextbutton}
                >
                  <span className="fontSecondaryText">
                    <Translate value="application.continue" />
                  </span>
                </Button>
              </div>
            </div>
          )}

          {showLoginConfirmModalBoolean && (
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around",
                textAlign: "center"
              }}
            >
              <div>
                <div style={{ fontSize: "3vh", marginBottom: "3vh" }}>
                  <Translate value="application.configuration.confirmlogginginas" />
                </div>
                <div style={{ fontSize: "3.5vh" }}>{loginLocationCode}</div>
                <div style={{ fontSize: "3.5vh", marginBottom: "3.5vh" }}>
                  {loginLocationName}
                </div>
                <div style={{ fontSize: "3.5vh", marginBottom: "3.5vh" }}>
                  {loginLocationAddress}
                </div>

                {loginWarning && (
                  <>
                    <div
                      style={{
                        fontSize: "2.2vh",
                        marginTop: "2vh",
                        fontStyle: "italic"
                      }}
                    >
                      <span style={{ fontWeight: "bold" }}>
                        <Translate value="application.configuration.warning" />:{" "}
                      </span>
                      <Translate value="application.configuration.confirmchangecollectorwarning" />{" "}
                      {warningSwitchFromCode}
                      {", "}
                      {warningSwitchFromName}
                    </div>
                  </>
                )}

                {!loginWarning && (
                  <>
                    <div style={{ fontSize: "3vh", marginTop: "2vh" }}>
                      <Translate value="application.configuration.confirmisthiscorrect" />
                    </div>
                  </>
                )}
              </div>
              <div>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={confirmLoginCancelFunc}
                  style={
                    kioskverticalstyles_2.configuration.confirmcancelbutton
                  }
                >
                  <span className="fontSecondaryText">
                    <Translate value="application.no" />
                  </span>
                </Button>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={confirmLoginAdvanceFunc}
                  style={kioskverticalstyles_2.configuration.confirmnextbutton}
                >
                  <span className="fontSecondaryText">
                    <Translate value="application.yes" />
                  </span>
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div style={kioskverticalstyles_2.footerDiv}>
        <LanguageButtons />
      </div>
    </div>
  );
}
